export default class AuthenticateMiddleware {

  constructor(authStore) {

    this.store = authStore

  }

  request(opts) {

    return {
      ...opts,
      withCredentials: true,
    }

  }

  response({ res }) {

    if (res && res.status === 200) {

      return res

    }

    if (res && res.status === 401) {
      this.store.handleUnauthorized()
    }

    return null

  }

}



// WEBPACK FOOTER //
// ./src/shared/api/middleware/auth.js